import { render, staticRenderFns } from "./ChatbotQuestionChart.vue?vue&type=template&id=d62a490a"
import script from "./ChatbotQuestionChart.vue?vue&type=script&lang=js"
export * from "./ChatbotQuestionChart.vue?vue&type=script&lang=js"
import style0 from "./ChatbotQuestionChart.vue?vue&type=style&index=0&id=d62a490a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports